import { createAsyncThunk } from "@reduxjs/toolkit";
import { getInfrastructureArchitectureDiagramThunk } from "@/store/infrastructure-architecture/thunks/getInfrastructureArchitectureDiagramThunk";
import { getInfrastructureArchitectureRecommendationThunk } from "@/store/infrastructure-architecture/thunks/getInfrastructureArchitectureRecommendationThunk";
import { RootState } from "@/store/store";
import { infrastructureArchitectureRecommendationDrawerExpandedSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureRecommendationDrawerExpandedSelector";
import { toggleRecommendationDrawerExpanded } from "@/store/infrastructure-architecture/infrastructureArchitectureSlice";

export const generateInfrastructureArchitectureThunk = createAsyncThunk(
  "infrastructureArchitecture/generateInfrastructureArchitecture",
  async (_, { dispatch, getState }) => {
    const state = getState() as RootState;
    const panelExpanded =
      infrastructureArchitectureRecommendationDrawerExpandedSelector(state);

    try {
      if (panelExpanded) {
        dispatch(toggleRecommendationDrawerExpanded());
      }

      const response = await dispatch(
        getInfrastructureArchitectureDiagramThunk(),
      ).unwrap();

      if (response) {
        await dispatch(
          getInfrastructureArchitectureRecommendationThunk(),
        ).unwrap();
      }
    } catch (e) {
      console.error("Error generating infrastructure architecture:", e);
    }
  },
);
